import Loading from '../../../Common/Loading';
import { useSpotsChartsDataContext } from './hooks/useSpotsChartsDataContext';
import { Spots } from './Spots';

export const Charts = () => {
    const { isLoading } = useSpotsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Spots />
        </>
    );
};
